import 'react';
import { Flex } from '../Flex/index.js';
import { NavMenuContainer, NavButton } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const VerticalNavigationLinkItem = props => {
  const {
    href,
    label,
    isActive,
    dataTestId,
    leftElement,
    hasNavigation,
    isComplete
  } = props;
  return jsx(NavButton, {
    href: href,
    "data-testid": dataTestId,
    active: isActive,
    "aria-disabled": !hasNavigation || isComplete,
    disabled: !hasNavigation || isComplete,
    cta: label,
    leftElement: leftElement,
    mb: 1
  });
};
const VerticalNavigation = ({
  items
}) => {
  return jsx(NavMenuContainer, {
    children: jsx(Flex.Column, {
      children: items.map(props => {
        const hasNavigation = 'href' in props;
        return jsx(VerticalNavigationLinkItem, {
          hasNavigation: hasNavigation,
          ...props
        }, `navLink-${props.label}`);
      })
    })
  });
};

export { VerticalNavigation };
